import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { getProgramsForUser } from '../../../scripts/api/applicationUserProgramApi';
import IndexItemDto from '../../../DTOs/shared/IndexItem';
import ProgramStaffHeader from './ProgramStaffHeader';
import DisplayAssignedPrograms from './DisplayAssignedPrograms';
import useToast from '../../shared/hooks/useToast';
import { message } from '../../shared/Message';
import { Toast } from 'primereact/toast';
import AddProgramAssignment from './AddProgramAssignment';

function ProgramStaffAssignmentTab({ userId, clientAssignmentType }) {
    const [programList, setProgramList] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const { toast, successToast, errorToast } = useToast();

    const fetchProgramsAssignedToUser = async () => {
        try {
            const result = await getProgramsForUser(userId);
            const assignedPrograms = result.programs.map(program => new IndexItemDto({
                title: program.name,
                description: program.description,
                itemId: program.id,
                url: `/Program/${program.id}`,
                isDisabled: false,
                endText: program.isSponsored ? 'Sponsored' : undefined
            }))

            setProgramList(assignedPrograms);
        } catch (error) {
            message.error(`Error occurred while fetching programs assigned to staff: ${error}`);
        }
    }

    const handleAddProgramAssignmentClick = () => setEditMode(true);
    const handleCancelEditClick = () => setEditMode(false);

    const handleAssignmentUpdate = () => {
        setEditMode(false);
        fetchProgramsAssignedToUser();
        successToast("Successfully assigned programs to this staff")
    }

    useEffect(() => {
        fetchProgramsAssignedToUser();
    }, [])

    return (
        <Container className="pb-3">
            <ProgramStaffHeader
                handleAddProgramAssignmentClick={handleAddProgramAssignmentClick} 
                editMode={editMode} 
                clientAssignmentType={clientAssignmentType}
            />

            {editMode && clientAssignmentType === 2 ?
                <AddProgramAssignment
                    staffId={userId}
                    currentAssignedPrograms={programList}
                    handleAssignmentUpdate={handleAssignmentUpdate}
                    errorToast={errorToast}
                    handleCancelClick={handleCancelEditClick}
                />

                : <DisplayAssignedPrograms programList={programList} />
            }

            <Toast ref={toast} position="bottom-left" />
        </Container>
    )
}

export default ProgramStaffAssignmentTab
